import { render, staticRenderFns } from "./InfoPage.vue?vue&type=template&id=6bcb24ea&"
import script from "./InfoPage.vue?vue&type=script&lang=js&"
export * from "./InfoPage.vue?vue&type=script&lang=js&"
import style0 from "./InfoPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports